<template>
  <div class="resource_course_list">
    <div class="title_header">
      {{selectDomName}}&nbsp;&nbsp;
      <i class="el-icon-edit" @click.stop="toAddMenu(selectTreeId)" v-if="topTreeId !== selectTreeId"></i>
      <i class="el-icon-delete" @click.stop="deleteMenu" v-if="topTreeId !== selectTreeId"></i>
    </div>
    <div class="header">
      <el-button size="medium" @click="$router.go(-1)">返回</el-button>
      <el-button size="medium" type="primary" @click="toAddMenu('')" v-if="selectTreeId">新增目录</el-button>
      <el-button size="medium" type="primary" @click="toAddCourse('')" v-if="selectTreeId">新增课程</el-button>
    </div>
    <div class="resource_content" :style="`height: ${windowHeight - 185}px;`">
      <div class="course_box">
        <div class="course_item" :key="index" v-for="(item, index) in dataList">
          <img src="https://cdnfile-10043692.file.myqcloud.com/admin/images/work_index.png" alt="">
          <div class="course_name" :title="item.name">{{item.name}}</div>
          <div class="btn_box">
            <i class="el-icon-edit" @click.stop="toAddCourse(item.id)"></i>
            <i class="el-icon-delete" @click.stop="deleteCourse(item.id)"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize';
  import {getChildAtlasDetailListByPid, deleteAtlasDetail} from '@/api/resourceMap'

  export default {
    name: "resourceCourseList",
    props: {
      selectTreeId: {
        type: String,
        default: '1'
      },
      topTreeId: {
        type: String,
        default: '1'
      },
      selectDomName: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        searchName: '',
        dataList: []
      }
    },
    watch: {
      selectTreeId() {
        // 数结构传值过来，接收后展示相对应数据
        this.getChildAtlasDetailListByPid();
      }
    },
    mounted() {
      this.getChildAtlasDetailListByPid();
    },
    mixins: [windowResize],
    methods: {
      toAddMenu(menuId) {
        if (menuId) {
          this.$router.push({path: 'menuAdd', query: {menuId: menuId}})
        } else {
          this.$router.push({path: 'menuAdd', query: {pidAtlasId: this.selectTreeId}})
        }
      },
      toAddCourse(courseId) {
        if (courseId) {
          this.$router.push({path: 'lessonAdd', query: {courseId: courseId}})
        } else {
          this.$router.push({path: 'lessonAdd', query: {pidAtlasId: this.selectTreeId}})
        }
      },
      getChildAtlasDetailListByPid() {
        if (this.selectTreeId) {
          getChildAtlasDetailListByPid({pidAtlasId: this.selectTreeId}).then(data => {
            this.dataList = data;
          })
        }
      },
      // 删除
      deleteCourse(id) {
        this.$confirm("确认要删除当前项吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        }).then(() => {
          deleteAtlasDetail({detailId: id}).then(() => {
            this.$message.success('删除成功！');
            this.getChildAtlasDetailListByPid();
          })
        }).catch(err => {});
      },
      deleteMenu() {
        this.$confirm("确认要删除此单元吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        }).then(() => {
          deleteAtlasDetail({detailId: this.selectTreeId}).then(() => {
            this.$message.success('删除成功！');
            window.setTimeout(() => {
              this.$emit('change-tree', '');
            }, 500);
          })
        });
      }
    }
  }
</script>

<style lang="scss">
  @import './../../../styles/mixin';

  .resource_course_list{
    padding-left: 15px;

    .title_header{
      height: 30px;
      line-height: 30px;
      margin-bottom: 5px;
      font-weight: bold;
      i{
        margin-left: 6px;
        font-size: 17px;
        font-weight: bold;
        color: #409eff;
        cursor: pointer;
      }
      .el-icon-delete{
        color: #F56C6C;
      }
    }
    .header {
      padding-bottom: 10px;
      .header_right_btn{
        float:right;
        margin-left: 10px;
      }
    }

    .resource_content{
      @include scrollBar;

      .course_box{
        @include clearfix;

        .course_item{
          position: relative;
          float: left;
          width: 210px;
          overflow: hidden;
          margin: 10px;
          border-radius: 4px;
          box-shadow: 5px 5px 10px rgba(0, 0, 0, .05), -5px 0 10px rgba(0, 0, 0, .05);
          transition: all .2s linear;

          img{
            display: block;
            width: 100%;
            height: 124px;
          }
          .course_name{
            text-align: center;
            height: 26px;
            line-height: 26px;
            padding: 0 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .btn_box{
            position: absolute;
            top: -124px;
            left: 0;
            display: flex;
            width: 210px;
            height: 124px;
            background: rgba(0,0,0,.5);
            transition: all .2s linear;
            i{
              flex: 1;
              text-align: center;
              line-height: 24px;
              margin: 50px 40px;
              color: #409eff;
              font-size: 20px;
              font-weight: bold;
              cursor: pointer;
            }
            .el-icon-delete{
              color: #F56C6C;
            }
          }
          &:hover{
            .btn_box{
              top: 0;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/study/resourceMap/resourceCourseList.vue